/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Stems_Foreground_HelpInputs */



/**
* | output |
* | --- |
* | "The isolated original dialogue, useful for checking timing." |
*
* @param {Audio_Stems_Foreground_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_stems_foreground_help = /** @type {((inputs?: Audio_Stems_Foreground_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Stems_Foreground_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les dialogues originaux isolés, utiles pour vérifier le timing.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der isolierte Originaldialog, hilfreich zum Prüfen des Timings.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I dialoghi originali isolati, utili per verificare la sincronizzazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отдельная исходная речь, удобна для проверки тайминга.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El diálogo original aislado, útil para comprobar la sincronización.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分离出的原始对白，便于检查时间。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分離した元の台詞。タイミングの確認に便利です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अलग किया गया मूल संवाद, टाइमिंग जाँचने के लिए उपयोगी।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O diálogo original isolado, útil para verificar a sincronização.")
	return /** @type {LocalizedString} */ ("The isolated original dialogue, useful for checking timing.")
});